
declare var  google:any;
export class googleNearResult {
  geocoder:any;
  map:any;

  findPlaces(types,radius,lat,long,map) {
    var finalResult;
    var cur_location = new google.maps.LatLng(lat,long);

    // prepare request to Places
    var request = {
      location: cur_location,
      radius: radius,
      types: [types]
    };

    var service = new google.maps.places.PlacesService(map); 
    service.nearbySearch(request, (results,status) => {
      if (status === google.maps.places.PlacesServiceStatus.OK) {
        finalResult=results;
      }else if (status == google.maps.places.PlacesServiceStatus.ZERO_RESULTS) {
        finalResult=results;
      }else{
        finalResult=results;
      }
    });
    return finalResult;
  } 
}